// Transient position for an explicit source change; no progress storage.
const createManualSourceTime = ({ group, path, identity, time, live }) =>
    !live && group && path && identity && Number.isFinite(time) && time >= 0
        ? { group, path, identity, time } : null;

const readManualSourceTime = (pending, { group, path, identity }) => {
    if (!pending || pending.group !== group || pending.path !== path) return { pending: null, time: null };
    // The route can update before Core finishes selecting the new source.
    if (pending.identity !== identity) return { pending, time: null };
    return { pending: null, time: pending.time };
};

module.exports = { createManualSourceTime, readManualSourceTime };
